import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Text from 'components/Text';

import { getText } from 'helpers/i18n';

// Styles
import '../../product.styles.scss';

// Images
import imgInStock from 'images/stock-in.svg';
import imgInsufficientStock from 'images/stock-insufficient.svg';
import imgOutOfStock from 'images/stock-out.svg';

export default class ProductStock extends Component {
    render() {
        const { availability, store, quantity } = this.props;

        if (!store || store === '0') {
            return null;
        }

        // No information
        if (!availability) {
            return (
                <div className="product__stock">
                    <p><Text textKey="product_location_no_info" /></p>
                </div>
            );
        }

        // Insufficient stock
        if (availability && quantity > availability.AvailableStock.$ && availability.AvailableStock.$ > 0) {
            return (
                <div className="product__stock product__stock-insufficient">
                    <p>
                        <img src={imgInsufficientStock} alt="" />
                        <span>
                            <Text textKey="product_location_insufficient_stock" />
                            <span className="product__stock-explanation"
                                dangerouslySetInnerHTML={{
                                    __html: getText('product_location_insufficient_stock_label', {
                                        quantity: availability.AvailableStock.$,
                                    }),
                                }}/>
                        </span>
                    </p>
                </div>
            );
        }

        // Available
        if (availability && availability.AvailableStock.$ > 0) {
            return (
                <div className="product__stock product__stock-in">
                    <p>
                        <img src={imgInStock} alt="" />
                        <span>
                            <Text textKey="product_location_in_stock" options={{
                                quantity: availability.AvailableStock.$,
                            }} />
                        </span>
                    </p>
                </div>
            );
        }

        // Out of stock
        return (
            <div className="product__stock product__stock-out">
                <p>
                    <img src={imgOutOfStock} alt="" />
                    <span><Text textKey="product_location_out_stock" /></span>
                </p>
            </div>
        );
    }
}

ProductStock.propTypes = {
    availability: PropTypes.object,
    store: PropTypes.string,
    quantity: PropTypes.number,
};
